module.exports = __webpack_public_path__ + "static/img/frutuba-tubaina.e85d989.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/thumbs/frutuba-tubaina.png
// module id = HFq2
// module chunks = 0